



















































import { ValidationProvider } from "vee-validate";
import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import colorPicker from "@caohenghu/vue-colorpicker";
import ClickOutside from "vue-click-outside";

@Component({
  components: {
    colorPicker,
    ValidationProvider,
  },
  directives: {
    ClickOutside,
  },
})
export default class FormColor extends Vue {
  @Prop() name?: string;

  @Prop() value?: string;

  @Prop() placeholder?: string;

  @Prop() rules?: string | object;

  @Prop() label?: string;

  @Prop({ default: true }) showError?: boolean;

  @Prop({ default: false }) disabled!: boolean;

  @Prop({ default: "text" }) type!: string;

  @Prop({ default: "text-14" }) labelClass!: string;

  @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

  isFocussed = false;

  localValue = "";

  open = false;

  changeColor(color: { hex: string }) {
    this.localValue = color.hex;
    this.$emit("input", this.localValue);
  }

  private get formValdiated(): boolean {
    return this.provider.$_veeObserver?.flags?.validated;
  }

  private get validateAs(): string {
    if (this.label) {
      return this.label;
    }

    if (this.placeholder) {
      return this.placeholder;
    }

    if (this.name) {
      return this.name;
    }

    return `${this.type} field`;
  }

  @Watch("value", { immediate: true })
  private valueChanged(newValue: string) {
    this.localValue = newValue;
  }
}
